'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  fetchSFVacanciesList () {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/spec-private/deloitte/vacancy/vacancy-list')
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  saveSFVacancyMap(sapVacancyId, params) {
    return new Promise((resolve, reject) => {
      Axios.post(`/1.0/spec-private/deloitte/vacancy/map/${sapVacancyId}`, params)
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  }
}